module.exports = __webpack_public_path__ + "img/book.85c908b8.png";